var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 18,
    viewBox: "0 0 9 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.199986 9C0.199986 8.3 0.469985 7.6 0.999985 7.07L7.51999 0.55C7.80999 0.26 8.28999 0.26 8.57999 0.55C8.86999 0.84 8.86999 1.32 8.57999 1.61L2.05999 8.13C1.57999 8.61 1.57999 9.39 2.05999 9.87L8.57998 16.39C8.86998 16.68 8.86998 17.16 8.57998 17.45C8.28998 17.74 7.80999 17.74 7.51999 17.45L0.999985 10.93C0.469985 10.4 0.199986 9.7 0.199986 9Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow_left.614e9922c849b05ce26aab4b98dac27f.svg";
export { ForwardRef as ReactComponent };